export const pricing = {
  "breadcrumb": "Prezzi",
  "title": "Tariffe semplici e flessibili",
  "subtitle": "Una commissione unica del 5%, pagata da chi vuoi.",
  "whoPays": {
    "title": "Chi paga le spese?",
    "traveler": {
      "label": "Opzione 1: Il viaggiatore paga (Consigliato)",
      "description": "Ricevi il 100% del tuo prezzo. Il viaggiatore aggiunge il 5% di costi di servizio.",
      "badge": "Predefinito"
    },
    "host": {
      "label": "Opzione 2: L'host paga (Pro)",
      "description": "Paghi tu il 5%. Prezzo mostrato più basso per il viaggiatore, ideale per le aziende.",
      "badge": "Opzione Pro"
    }
  },
  "guarantee": "Trasparenza totale garantita",
  "perYear": "/anno",
  "choose": "Scegliere",
  "popular": "Il più popolare",
  "plans": {
    "traveler": {
      "name": "Viaggiatore",
      "description": "Per esplorare il mondo a costi ridotti",
      "price": "5%",
      "period": "di commissione",
      "features": [
        "Accesso a tutti gli alloggi",
        "Costi di servizio ridotti (5%)",
        "Assicurazione inclusa",
        "Supporto 7/7",
        "Nessun costo nascosto"
      ]
    },
    "host": {
      "name": "Ospitante",
      "description": "Per affittare senza spese e scambiare",
      "price": "0%",
      "period": "di commissione",
      "features": [
        "0% di commissione sulle tue entrate",
        "Accesso agli scambi gratuiti tra ospitanti",
        "Badge \"Prezzo Equo\" disponibile",
        "Visibilità aumentata",
        "Supporto prioritario"
      ]
    }
  },
  "fairPrice": {
    "title": "Programma Prezzo Giusto",
    "description": "Stai al gioco, guadagna di più.",
    "benefit1": "Badge 'Prezzo Giusto' visibile",
    "benefit2": "Priorità nei risultati",
    "benefit3": "Bonus punti scambio",
    "condition": "Proponi una tariffa almeno 10% più economica rispetto alle altre piattaforme."
  },
  "taxAdvantage": {
    "title": "Vantaggio Fiscale & Pro",
    "text": "Le spese del 5% possono essere deducibili dalle tue spese se sei un'azienda. Il modello 0% semplifica la contabilità dei privati. Consulta il tuo commercialista."
  },
  "hostExchange": {
    "title": "Sistema di Scambio tra Ospitanti",
    "description": "Scambia le tue notti guadagnate con soggiorni gratuiti.",
    "free": "Gratuito (0€)",
    "community": "Riservato ai membri verificati"
  },
  "comparison": {
    "title": "Perché è meglio?",
    "subtitle": "Confronta e vedi la differenza",
    "features": "Spese",
    "airbnb": "Airbnb / Booking",
    "traveltrok": "DONKEY TRAVEL",
    "hostFees": "Spese Ospitante",
    "travelerFees": "Spese Viaggiatore",
    "exchange": "Scambio Gratuito"
  },
  "testimonials": {
    "title": "Cosa dicono i nostri membri",
    "subtitle": "Unisciti a una comunità che cambia le regole",
    "badge": "Testimonianze",
    "exchanges": "scambi",
    "saved": "risparmiati",
    "verifiedMembers": "+15 000 membri",
    "completedExchanges": "+50 000 viaggi",
    "totalSaved": "0% di commissione"
  },
  "faq": {
    "title": "Domande frequenti",
    "subtitle": "Tutto quello che devi sapere sulle nostre tariffe",
    "q1": {
      "question": "Posso cambiare piano in qualsiasi momento?",
      "answer": "Sì, puoi passare a un piano superiore in qualsiasi momento. La differenza sarà calcolata in proporzione al tuo abbonamento attuale."
    },
    "q2": {
      "question": "Ci sono costi aggiuntivi?",
      "answer": "No, nessun costo nascosto. Il prezzo visualizzato è il prezzo finale che paghi all'anno. Gli scambi sono poi totalmente gratuiti."
    },
    "q3": {
      "question": "Cosa succede se non sono soddisfatto?",
      "answer": "Offriamo una garanzia \"soddisfatti o rimborsati\" di 30 giorni. Se non sei soddisfatto, ti rimborsiamo integralmente."
    },
    "q4": {
      "question": "Come funziona la fatturazione?",
      "answer": "Sei fatturato annualmente. Puoi pagare con carta di credito o bonifico. La fatturazione è automatica e ricevi una fattura via email."
    },
    "q5": {
      "question": "Posso annullare il mio abbonamento?",
      "answer": "Sì, puoi annullare in qualsiasi momento. Il tuo abbonamento rimarrà attivo fino alla fine del periodo pagato."
    }
  },
  "cta": {
    "title": "Pronto a iniziare l'avventura?",
    "subtitle": "Unisciti a migliaia di proprietari che viaggiano gratuitamente",
    "createAccount": "Crea il mio account",
    "exploreDestinations": "Esplora le destinazioni"
  },
  "signup": {
    "title": "Crea il tuo account",
    "subtitle": "Unisciti alla nostra comunità di proprietari",
    "firstName": "Nome",
    "lastName": "Cognome",
    "email": "Email",
    "phone": "Telefono",
    "country": "Paese",
    "selectCountry": "Seleziona il tuo paese",
    "plan": "Piano",
    "selectPlan": "Seleziona il tuo piano",
    "propertyType": "Tipo di alloggio",
    "selectPropertyType": "Seleziona il tipo di alloggio",
    "terms": "Accetto le condizioni d'uso e la politica sulla privacy",
    "submit": "Crea il mio account",
    "success": "Account creato con successo!",
    "error": "Si è verificato un errore. Riprova.",
    "securityNote": "I tuoi dati sono al sicuro e non saranno mai condivisi",
    "house": "Casa",
    "apartment": "Appartamento",
    "villa": "Villa",
    "loft": "Loft",
    "other": "Altro"
  },
  "signupSection": {
    "title": "Unisciti a DONKEY TRAVEL oggi",
    "subtitle": "Crea il tuo account in pochi minuti e inizia a scambiare la tua casa con proprietari di tutto il mondo.",
    "verifiedMembers": "Membri verificati",
    "verifiedMembersDesc": "Tutti i nostri membri sono proprietari Airbnb verificati per scambi in completa fiducia.",
    "guaranteedSavings": "Risparmi garantiti",
    "guaranteedSavingsDesc": "I nostri membri risparmiano in media 3.500€ all'anno sulle spese di alloggio.",
    "globalNetwork": "Rete globale",
    "globalNetworkDesc": "Accedi a più di 15.000 alloggi in 85 paesi nel mondo.",
    "responsiveSupport": "Supporto reattivo",
    "responsiveSupportDesc": "Il nostro team è disponibile 7/7 per accompagnarti nei tuoi scambi."
  },
  "testimonialItems": {
    "sophie": "Grazie a DONKEY TRAVEL, ho visitato Barcellona, Roma e Amsterdam senza pagare alloggio. La comunità è reattiva e le discussioni di scambio sono semplici.",
    "thomas": "Ho aderito all'offerta di lancio 2026: -50% il primo anno. Il prezzo è garantito a vita per i primi 1000, e scambio ovunque in Europa.",
    "marie": "Ho finalmente fatto il mio primo scambio in Europa, e tutto è stato fluido dal primo messaggio fino all'arrivo. La verifica dei profili aiuta davvero.",
    "pierre": "Per i nostri alloggi, il pannello ci fa risparmiare tempo: annunci, messaggi e disponibilità sono chiari e facili da gestire."
  }
};
